/**
 * @generated SignedSource<<92626263d46486a20127942a6651d523>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentFormDiscountSection_Discount$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Discount_displayValue">;
  readonly " $fragmentType": "PaymentFormDiscountSection_Discount";
};
export type PaymentFormDiscountSection_Discount$key = {
  readonly " $data"?: PaymentFormDiscountSection_Discount$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentFormDiscountSection_Discount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentFormDiscountSection_Discount",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Discount_displayValue"
    }
  ],
  "type": "Discount",
  "abstractKey": null
};

(node as any).hash = "d9c8b9776b74ee3799ecc8a2ceed8fd2";

export default node;
